export class AxisNames {
  static get X() { return 'axis_x' }
  static get X2() { return 'axis_x2' }
  static get Y() { return 'axis_y' }
  static get Y2() { return 'axis_y2' }
}

export class Orientations {
  static get Bottom() { return 'bottom' }
  static get Left() { return 'left' }
  static get Horizontal() { return 'horizontal' }
  static get Right() { return 'right' }
  static get Top() { return 'top' }
  static get Vertical() { return 'vertical' }
}

export class DomainTypes {
  static get MinMax() { return 'range-type-min-max' }
  static get RowSum() { return 'range-type-row-sum' }
}

export class ScaleTypes {
  static get Band() { return 'band' }
  static get Cardinal() { return 'cardinal' }
  static get Linear() { return 'linear' }
  static get Log() { return 'log' }
  static get Power() { return 'power' }
  static get SquareRoot() { return 'square-root' }
  static get TimeSeries() { return 'time-series' }
}
